import Vue from 'vue'
import Router from 'vue-router'
import LandingPage from '../components/LandingPage'
import LandingPage2 from '../components/LandingPage2'
import Bot from '../components/Bot'
import ChatButton from '../components/ChatButton'
import ChatBubble2 from '../components/ChatBubble2'
import Bot2 from '../components/Bot2'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'ChatManaging',
      component: LandingPage
    },

    {
      path: '/botdemopage',
      name: 'botDemoPage',
      component: Bot
    },

    {
      path: '/chatbutton',
      name: 'chatButton',
      component: ChatButton
    },

    {
      path: '/chatbubble',
      name: 'chatBubble',
      component: ChatBubble2
    },

    {
      path: '/bot',
      name: 'bot',
      component: Bot2
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js